import { render, staticRenderFns } from "./sendlog.vue?vue&type=template&id=bb56e3ba&scoped=true"
import script from "./sendlog.vue?vue&type=script&lang=js"
export * from "./sendlog.vue?vue&type=script&lang=js"
import style0 from "./sendlog.vue?vue&type=style&index=0&id=bb56e3ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb56e3ba",
  null
  
)

export default component.exports